<template>
  <div>
    <v-card class="main-container">
      <v-card-title style="color:gray; font-weight:bold; padding-left: 0px;">

        <div style="width: 1000px; margin-left: 20px;">

          <v-tabs v-model="activeTab"  fixed-tabs>
            <v-tab :key="0">Текущие</v-tab>
            <v-tab :key="1">Архив</v-tab>
          </v-tabs>
        </div>
      </v-card-title>

      <v-card-text>
        <v-list class="d-flex align-center justify-start">
          <v-list-item v-if="activeTab == 0">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
            <v-btn
              style="background-color: #ef0000  !important;"
              @click=""
              v-bind="attrs"
              v-on="on"
              x-small>
                {{ 'Горит!)' }}
            </v-btn>
          </template>
            <span>Новый запрос.Обратите внимание на дату создания.</span>
            </v-tooltip>
          </v-list-item>
          <v-list-item v-if="activeTab == 0">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  style="background-color: #a9a9a9 !important;"
                  @click=""
                  v-bind="attrs"
                  v-on="on"
                  x-small
                >
                  Новый запрос
                </v-btn>
              </template>
              <span>"Возьмите в работу" или "Отклоните" если пользователь указал некорректные или недостаточные данные</span>
            </v-tooltip>
          </v-list-item>

          <v-list-item v-if="activeTab == 0">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
            <v-btn
              style="background-color: #ada509 !important;"
              @click=""
              v-bind="attrs"
              v-on="on"
              x-small>
                В работе
            </v-btn>
          </template>
            <span> После оформления документа подгрузите скан и нажмите "Оформлен". Инициатор запроса узнает, что все готово) </span>
            </v-tooltip>
          </v-list-item>
          <v-list-item v-if="activeTab == 1">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
            <v-btn
              style="background-color: #1b8e30 !important;"
              @click=""
              v-bind="attrs"
              v-on="on"
              x-small>
                Готов
            </v-btn>
          </template>
            <span>Спасибо!</span>
            </v-tooltip>
          </v-list-item>
          <v-list-item v-if="activeTab == 1">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
            <v-btn
              style="background-color: #E57373  !important;"
              @click=""
              v-bind="attrs"
              v-on="on"
              x-small>
                Отменен
            </v-btn>
          </template>
            <span>документ не оформлен</span>
            </v-tooltip>
          </v-list-item>
        </v-list>

        <v-tabs-items>
          <v-data-table
            :style="{color: $mainColor}"
            :headers="current_headers"
            :items="listInvitations"
            :loading="preloaderYet"
            :loading-text="$t('User.loading_orders')"
            :items-per-page="10"
            :footer-props="{
                itemsPerPageOptions: [10, 50, -1],
                itemsPerPageText: 'кол-во на стр.:',
            }"
          >
            <template v-slot:item.id="{ item }">
              <span @click="openDetailInfo(item)" style="cursor: pointer;">
                {{ item.id }}
              </span>
            </template>
            <template v-slot:item.created_at="{ item }">
              <span @click="openDetailInfo(item)" style="cursor: pointer;">
                <v-chip
                  :color="get_color(item)"
                  dark
                >
                  {{ g.toDate(item.created_at) }}
                </v-chip>
              </span>
            </template>
            
            <template v-slot:item.type="{ item }">
              <span @click="openDetailInfo(item)" style="cursor: pointer;">
                {{ item.type == 1 ? 'Приглашение' : 'Справка' }}
              </span>
            </template>

            <template v-slot:item.comments="{ item }">
              <v-tooltip left v-if="item.user_comment != null && item.user_comment.length > 0">
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="show_comment(item.user_comment)">
                    mdi-comment-text
                    </v-icon>
                </template>
                <span>{{ item.user_comment }}</span>
              </v-tooltip>
              <v-tooltip left v-if="item.admin_comment != null && item.admin_comment.length > 0">
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="show_comment(item.admin_comment)">
                    mdi-comment-text
                    </v-icon>
                </template>
                <span>{{ item.admin_comment }}</span>
              </v-tooltip>
            </template>

            <template v-slot:item.creator="{ item }">
              <span @click="openDetailInfo(item)" style="cursor: pointer;">
                {{ item.creator }}
              </span>

            </template>

            <template v-slot:item.proposal_id="{ item }">
              <span @click="openProposalInfo(item.proposal_id)" style="cursor: pointer;">
                #{{ item.proposal_id }}
              </span>
            </template>            
          </v-data-table>
        </v-tabs-items>            
      </v-card-text>
    </v-card>

    <v-dialog v-model="invitation_card_dialog" max-width="75%">
      <invitation-modal-card
        @updateParent="update_parent($event.item, $event.close_modal)"
      />
    </v-dialog>

    <v-dialog v-model="show_comment_dialog" max-width="40%">
      <v-card>
        <v-card-title class="headline">Комментарий эксперта
        </v-card-title>
        <v-card-text>{{ show_comment_dialog_text }}
        </v-card-text>


        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="show_comment_dialog = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import invitationModalCard from '../components/Common/Invitation/modalCard.vue'

export default {
  name: 'Invitations',

  components: {
    invitationModalCard
  },

  data() {
    return {
      current_headers: [
          { text: 'ID', sortable: true, value: 'id'},
          { text: 'Дата создания', sortable: true, value: 'created_at'},
          { text: 'Тип', sortable: true, value: 'type'},
          { text: 'Комментарии', sortable: false, value: 'comments'},
          { text: 'Инициатор', sortable: false, value: 'creator'},
          { text: 'Proposal', sortable: false, value: 'proposal_id'},
      ],
      listInvitation: [],

      preloaderYet: false,
      activeTab: 0,

      invitation_card_dialog: false,
      current_invitation_id: 0,

      red_date: new Date(),
      show_comment_dialog: false,
      show_comment_dialog_text: '',
      call_id: null,
    };
  },

  async beforeMount() {
      this.activeTab = 0

      this.red_date.setDate(this.red_date.getDate() - 2)
      var mm = this.red_date.getMonth() + 1;
      mm = Number(mm) < 10 ? `0${mm}` : mm
      var dd = this.red_date.getDate() 
      dd = Number(dd) < 10 ? `0${dd}` : dd

      this.red_date =  this.red_date.getFullYear() + '-' + mm + '-' + dd; 

    this.loadNewRequest();
  },

  computed: {
    ...mapGetters([
      'GETTERS_NEED_RELOAD_CLOSE_PROPOSAL',
    ])
  },

  methods:{
    ...mapActions([
      'GET_LIST_INVITATION',
      'GET_INVITATION_ALL',
    ]),
    ...mapMutations([
      'SHOW_PROPOSAL_CARD',
      'UPDATE_OVERLAY',
    ]),


    get_color(item){
      if(item.status == 2)
        return '#ada509'
      else if(item.status == 4)
        return '#e57373'
      else if(item.status == 3)
        return '#1b8e30'
      else if(item.status == 1){
        if(item.created_at.split('T')[0] < this.red_date)
          return '#ef0000'
        else
          return '#a9a9a9'
      }
      else
        return 'yellow'


    },

    show_comment(text){
      this.show_comment_dialog_text = text
      this.show_comment_dialog = true
    },

    openProposalInfo(proposal_id){
        this.call_id = new Date()
        this.SHOW_PROPOSAL_CARD({
          'proposal_id' : proposal_id,
          'call_id': this.call_id
        })
    },

    openDetailInfo(invitation){
      this.current_invitation_id = invitation.id
      this.UPDATE_OVERLAY(true)
      this.GET_INVITATION_ALL(this.current_invitation_id)
        .then(() => {
          this.UPDATE_OVERLAY(false)
          this.invitation_card_dialog = true
        })        
    },

    update_parent(item, close_modal = true) {
      if(close_modal)
        this.invitation_card_dialog = false;
      if(item == -1)
        this.loadNewRequest()

      this.GET_INVITATION_ALL(this.current_invitation_id)
    },

    loadNewRequest() {
      this.preloaderYet = true;
      this.listInvitations = [];

      this.GET_LIST_INVITATION({status_id: this.activeTab, view_type: 'admin'})
        .then((res) => {
          this.preloaderYet = false;
          this.listInvitations = res.data;
        })
        .catch(() => this.preloaderYet = false);
    },
  },

  watch: {
    activeTab(val) {
      this.loadNewRequest(val)
    },

    GETTERS_NEED_RELOAD_CLOSE_PROPOSAL(val){
      if(val && val == this.call_id){
          this.loadNewRequest()
      }
    },
      }

};
</script>
